'use client';
import { useLangueArrivee } from '@/app/lib/use-langue-arrivee';

const CONTENT = {
  fr: {
    title: 'Politique de confidentialité',
    subtitle: 'Conforme au Règlement (UE) 2016/679 (RGPD) et à la loi belge du 30 juillet 2018',
    updated: 'Dernière mise à jour : 26 avril 2026',
    s1_title: '1. Responsable du traitement',
    s1_p1: 'Aureus IA SRL, BCE BE 1028.230.781, Square Eugène Plasky 92-94 bte 11, 1030 Schaerbeek, Bruxelles. Email : info@aureussocial.be.',
    s1_p2: 'Aureus IA SRL agit en qualité de responsable du traitement pour les données de ses clients directs (utilisateurs du Service) et en qualité de sous-traitant au sens de l\'Art. 28 RGPD pour le traitement des données salariées de ses Clients.',
    s2_title: '2. Données collectées',
    s2_th: ['Catégorie', 'Exemples', 'Finalité'],
    s2_rows: [
      ['Identification', 'Nom, NISS, date de naissance', 'Génération paie, déclarations sociales'],
      ['Coordonnées', 'Adresse, email, téléphone', 'Communication, fiches de paie'],
      ['Contractuelles', 'Type contrat, salaire, fonctions, CP', 'Calcul paie, conformité droit social'],
      ['Bancaires', 'IBAN (chiffré AES-256-GCM)', 'Virements salaires (SEPA)'],
      ['Connexion', 'Logs accès, IP, agent navigateur', 'Sécurité, audit trail'],
    ],
    s3_title: '3. Bases juridiques (Art. 6 RGPD)',
    s3_li: [
      'Exécution du contrat (Art. 6.1.b) : gestion de la paie et des déclarations sociales obligatoires.',
      'Obligation légale (Art. 6.1.c) : Dimona, DmfA, Belcotax, conservation des fiches de paie (7 ans — Art. 315 CIR 1992).',
      'Intérêt légitime (Art. 6.1.f) : sécurité, prévention de la fraude, amélioration du service.',
      'Consentement (Art. 6.1.a) : communications marketing optionnelles, cookies non strictement nécessaires.',
    ],
    s4_title: '4. Hébergement et sous-traitants techniques',
    s4_th: ['Service', 'Fournisseur', 'Localisation', 'Rôle'],
    s4_rows: [
      ['Base de données', 'Supabase', 'Frankfurt, Allemagne (UE)', 'Stockage et authentification'],
      ['Application web', 'Vercel', 'Edge EU', 'Hébergement de l\'application'],
      ['Sauvegardes', 'Backblaze B2', 'EU Central', 'Backup chiffré quotidien'],
      ['Emails transactionnels', 'Resend', 'UE', 'Envoi fiches de paie'],
      ['Agent IA juridique', 'AWS Bedrock (Claude) + Anthropic', 'UE — Francfort (principal) / USA — ZDR + SCC (flux temps réel)', 'Réponses agent IA droit social (sans stockage)'],
    ],
    s4_p: 'Le traitement IA s\'effectue dans l\'Union européenne via AWS Bedrock (région Francfort, eu-central-1) lorsque la passerelle d\'inférence UE est activée ; aucune donnée n\'est alors transférée hors UE. Lorsque cette passerelle n\'est pas active, les requêtes transitent par l\'API Anthropic (États-Unis) sous régime Zero Data Retention et Standard Contractual Clauses (SCC) de la Commission européenne. Dans tous les cas, les identifiants directs (numéro de registre national/NISS, IBAN, e-mail, téléphone) sont automatiquement pseudonymisés (masqués) avant tout envoi.',
    s5_title: '5. Sous-traitants',
    s5_p: 'Conformément à l\'article 28 du RGPD, les sous-traitants suivants sont autorisés. Un accord de traitement des données (DPA) ou des clauses contractuelles types (SCC) sont conclus avec chacun d\'entre eux : Supabase Inc. (hébergement, UE), Vercel Inc. (déploiement, UE), Resend Inc. (emails transactionnels, UE), Backblaze Inc. (sauvegardes, UE), Amazon Web Services EMEA SARL (inférence IA Bedrock, UE — Francfort), Anthropic PBC (API IA flux temps réel, USA — ZDR + SCC).',
    s6_title: '6. Vos droits (Art. 15 à 22 RGPD)',
    s6_li: [
      'Droit d\'accès (Art. 15) — communication des données traitées dans un délai de 30 jours.',
      'Droit de rectification (Art. 16) — correction des données inexactes.',
      'Droit à l\'effacement (Art. 17) — suppression des données (sauf obligation légale).',
      'Droit à la portabilité (Art. 20) — export des données dans un format structuré (JSON/CSV).',
      'Droit d\'opposition (Art. 21) — droit de s\'opposer au traitement.',
      'Droit à la limitation (Art. 18) — restriction du traitement.',
    ],
    s6_contact: 'Pour exercer vos droits, contactez-nous à info@aureussocial.be. Nous vous répondrons dans un délai d\'un mois (Art. 12.3 RGPD).',
    s7_title: '7. Violation de données',
    s7_p: 'En cas de violation de données à caractère personnel, Aureus IA SRL s\'engage à : notifier l\'Autorité de Protection des Données (APD) dans les 72 heures conformément à l\'article 33 du RGPD ; informer les personnes concernées sans délai si la violation est susceptible d\'engendrer un risque élevé pour leurs droits et libertés (Art. 34 RGPD) ; documenter l\'incident et les mesures correctives prises.',
    s8_title: '8. Cookies',
    s8_p: 'Aureus Social Pro utilise exclusivement des cookies strictement nécessaires au fonctionnement du Service (session d\'authentification, token CSRF, préférences d\'interface). Aucun cookie de tracking, analytique ou publicitaire n\'est utilisé. Ces cookies fonctionnels sont exemptés de consentement conformément à l\'article 5(3) de la Directive ePrivacy 2002/58/CE.',
    s9_title: '9. Autorité de contrôle',
    s9_apd: ['Autorité de Protection des Données (APD)', 'Rue de la Presse 35, 1000 Bruxelles', 'Tél : +32 2 274 48 00', 'Site : www.autoriteprotectiondonnees.be', 'Email : contact@apd-gba.be'],
    s9_p: 'Si vous estimez que le traitement de vos données constitue une violation du RGPD, vous avez le droit d\'introduire une réclamation auprès de l\'APD.',
    s10_title: '10. Modifications',
    s10_p: 'La présente politique peut être modifiée pour refléter les évolutions légales ou techniques. Toute modification substantielle sera notifiée par email aux Clients au moins 30 jours avant son entrée en vigueur. La version en vigueur est toujours disponible à l\'adresse www.aureussocial.be/legal/privacy.',
    footer: 'Document généré le 26 avril 2026 — Version 2.0',
  },
  nl: {
    title: 'Privacybeleid',
    subtitle: 'Conform de Verordening (EU) 2016/679 (AVG) en de Belgische wet van 30 juli 2018',
    updated: 'Laatste update: 26 april 2026',
    s1_title: '1. Verwerkingsverantwoordelijke',
    s1_p1: 'Aureus IA SRL, KBO BE 1028.230.781, Square Eugène Plasky 92-94 bte 11, 1030 Schaarbeek, Brussel. E-mail: info@aureussocial.be.',
    s1_p2: 'Aureus IA SRL treedt op als verwerkingsverantwoordelijke voor de gegevens van haar directe klanten (gebruikers van de Dienst) en als verwerker in de zin van Art. 28 AVG voor de verwerking van loongegevens van haar Klanten.',
    s2_title: '2. Verzamelde gegevens',
    s2_th: ['Categorie', 'Voorbeelden', 'Doel'],
    s2_rows: [
      ['Identificatie', 'Naam, RR-nummer, geboortedatum', 'Loonberekening, sociale aangiften'],
      ['Contactgegevens', 'Adres, e-mail, telefoon', 'Communicatie, loonfiches'],
      ['Contractueel', 'Type contract, loon, functies, PC', 'Loonberekening, conformiteit sociaal recht'],
      ['Bankgegevens', 'IBAN (versleuteld AES-256-GCM)', 'Loonoverschrijvingen (SEPA)'],
      ['Verbinding', 'Toegangslogs, IP, browser', 'Beveiliging, audit trail'],
    ],
    s3_title: '3. Rechtsgronden (Art. 6 AVG)',
    s3_li: [
      'Uitvoering van het contract (Art. 6.1.b): loonbeheer en verplichte sociale aangiften.',
      'Wettelijke verplichting (Art. 6.1.c): Dimona, DmfA, Belcotax, bewaring loonfiches (7 jaar — Art. 315 WIB 1992).',
      'Gerechtvaardigd belang (Art. 6.1.f): beveiliging, fraudepreventie, dienstverbetering.',
      'Toestemming (Art. 6.1.a): optionele marketingcommunicatie, niet-strikt noodzakelijke cookies.',
    ],
    s4_title: '4. Hosting en technische verwerkers',
    s4_th: ['Dienst', 'Leverancier', 'Locatie', 'Rol'],
    s4_rows: [
      ['Database', 'Supabase', 'Frankfurt, Duitsland (EU)', 'Opslag en authenticatie'],
      ['Webapplicatie', 'Vercel', 'Edge EU', 'Hosting van de applicatie'],
      ['Back-ups', 'Backblaze B2', 'EU Central', 'Dagelijkse versleutelde back-up'],
      ['Transactionele e-mails', 'Resend', 'EU', 'Verzending loonfiches'],
      ['Juridische AI-agent', 'AWS Bedrock (Claude) + Anthropic', 'EU — Frankfurt (hoofdzakelijk) / VS — ZDR + SCC (realtime stromen)', 'Antwoorden AI-agent sociaal recht (zonder opslag)'],
    ],
    s4_p: 'AI-verwerking gebeurt binnen de Europese Unie via AWS Bedrock (regio Frankfurt, eu-central-1) wanneer de EU-inferentiegateway is geactiveerd; er worden dan geen gegevens buiten de EU doorgegeven. Wanneer deze gateway niet actief is, lopen de aanvragen via de Anthropic API (Verenigde Staten) onder Zero Data Retention regime en Standard Contractual Clauses (SCC) van de Europese Commissie. In alle gevallen worden directe identificatoren (rijksregisternummer/INSZ, IBAN, e-mail, telefoon) automatisch gepseudonimiseerd (gemaskeerd) vóór elke verzending.',
    s5_title: '5. Verwerkers',
    s5_p: 'Conform artikel 28 AVG zijn volgende verwerkers gemachtigd. Een verwerkersovereenkomst (DPA) of standaardcontractbepalingen (SCC) zijn met elk van hen gesloten: Supabase Inc. (hosting, EU), Vercel Inc. (deployment, EU), Resend Inc. (transactionele e-mails, EU), Backblaze Inc. (back-ups, EU), Amazon Web Services EMEA SARL (AI-inferentie Bedrock, EU — Frankfurt), Anthropic PBC (AI API realtime stromen, VS — ZDR + SCC).',
    s6_title: '6. Uw rechten (Art. 15 tot 22 AVG)',
    s6_li: [
      'Recht op inzage (Art. 15) — mededeling van verwerkte gegevens binnen 30 dagen.',
      'Recht op rectificatie (Art. 16) — correctie van onjuiste gegevens.',
      'Recht op wissing (Art. 17) — verwijdering van gegevens (behalve wettelijke verplichting).',
      'Recht op overdraagbaarheid (Art. 20) — export in gestructureerd formaat (JSON/CSV).',
      'Recht van bezwaar (Art. 21) — recht om bezwaar te maken tegen de verwerking.',
      'Recht op beperking (Art. 18) — beperking van de verwerking.',
    ],
    s6_contact: 'Om uw rechten uit te oefenen, contacteer info@aureussocial.be. Wij antwoorden binnen één maand (Art. 12.3 AVG).',
    s7_title: '7. Inbreuk op gegevens',
    s7_p: 'In geval van een inbreuk op persoonsgegevens verbindt Aureus IA SRL zich ertoe: de Gegevensbeschermingsautoriteit (GBA) binnen 72 uur conform artikel 33 AVG te informeren; betrokkenen onverwijld te informeren indien de inbreuk een hoog risico voor hun rechten en vrijheden kan inhouden (Art. 34 AVG); het incident en de genomen corrigerende maatregelen te documenteren.',
    s8_title: '8. Cookies',
    s8_p: 'Aureus Social Pro gebruikt uitsluitend strikt noodzakelijke cookies voor de werking van de Dienst (authenticatiesessie, CSRF-token, interfacevoorkeuren). Geen tracking-, analytische of advertentiecookies worden gebruikt. Deze functionele cookies zijn vrijgesteld van toestemming conform artikel 5(3) van de ePrivacy-richtlijn 2002/58/EG.',
    s9_title: '9. Toezichthoudende autoriteit',
    s9_apd: ['Gegevensbeschermingsautoriteit (GBA)', 'Drukpersstraat 35, 1000 Brussel', 'Tel: +32 2 274 48 00', 'Site: www.gegevensbeschermingsautoriteit.be', 'E-mail: contact@apd-gba.be'],
    s9_p: 'Indien u meent dat de verwerking van uw gegevens een schending van de AVG vormt, heeft u het recht een klacht in te dienen bij de GBA.',
    s10_title: '10. Wijzigingen',
    s10_p: 'Dit beleid kan worden gewijzigd om wettelijke of technische evoluties te weerspiegelen. Elke substantiële wijziging wordt minstens 30 dagen vóór inwerkingtreding per e-mail aan de Klanten meegedeeld. De geldende versie is altijd beschikbaar op www.aureussocial.be/legal/privacy.',
    footer: 'Document gegenereerd op 26 april 2026 — Versie 2.0',
  },
  en: {
    title: 'Privacy Policy',
    subtitle: 'Compliant with Regulation (EU) 2016/679 (GDPR) and the Belgian Act of 30 July 2018',
    updated: 'Last updated: 26 April 2026',
    s1_title: '1. Data controller',
    s1_p1: 'Aureus IA SRL, BCE BE 1028.230.781, Square Eugène Plasky 92-94 bte 11, office 10, 1030 Schaerbeek, Brussels. Email: info@aureussocial.be.',
    s1_p2: 'Aureus IA SRL acts as data controller for the data of its direct clients (Service users) and as data processor within the meaning of Art. 28 GDPR for the processing of its Clients\' employee data.',
    s2_title: '2. Data collected',
    s2_th: ['Category', 'Examples', 'Purpose'],
    s2_rows: [
      ['Identification', 'Name, NRN, date of birth', 'Payroll generation, social declarations'],
      ['Contact details', 'Address, email, phone', 'Communication, payslips'],
      ['Contractual', 'Contract type, salary, functions, JC', 'Payroll calculation, social law compliance'],
      ['Banking', 'IBAN (encrypted AES-256-GCM)', 'Salary transfers (SEPA)'],
      ['Connection', 'Access logs, IP, browser agent', 'Security, audit trail'],
    ],
    s3_title: '3. Legal bases (Art. 6 GDPR)',
    s3_li: [
      'Performance of contract (Art. 6.1.b): payroll management and mandatory social declarations.',
      'Legal obligation (Art. 6.1.c): Dimona, DmfA, Belcotax, payslip retention (7 years — Art. 315 ITC 1992).',
      'Legitimate interest (Art. 6.1.f): security, fraud prevention, service improvement.',
      'Consent (Art. 6.1.a): optional marketing communications, non-strictly necessary cookies.',
    ],
    s4_title: '4. Hosting and technical processors',
    s4_th: ['Service', 'Provider', 'Location', 'Role'],
    s4_rows: [
      ['Database', 'Supabase', 'Frankfurt, Germany (EU)', 'Storage and authentication'],
      ['Web application', 'Vercel', 'Edge EU', 'Application hosting'],
      ['Backups', 'Backblaze B2', 'EU Central', 'Daily encrypted backup'],
      ['Transactional emails', 'Resend', 'EU', 'Sending payslips'],
      ['Legal AI agent', 'AWS Bedrock (Claude) + Anthropic', 'EU — Frankfurt (primary) / USA — ZDR + SCC (real-time streams)', 'Legal AI agent responses (no storage)'],
    ],
    s4_p: 'AI processing takes place within the European Union via AWS Bedrock (Frankfurt region, eu-central-1) when the EU inference gateway is enabled; no data is then transferred outside the EU. When this gateway is not active, requests transit through the Anthropic API (United States) under a Zero Data Retention regime and the European Commission\'s Standard Contractual Clauses (SCC). In all cases, direct identifiers (national register number/NISS, IBAN, email, telephone) are automatically pseudonymized (masked) before any transmission.',
    s5_title: '5. Processors',
    s5_p: 'In accordance with Article 28 GDPR, the following processors are authorized. A Data Processing Agreement (DPA) or Standard Contractual Clauses (SCC) are concluded with each of them: Supabase Inc. (hosting, EU), Vercel Inc. (deployment, EU), Resend Inc. (transactional emails, EU), Backblaze Inc. (backups, EU), Amazon Web Services EMEA SARL (Bedrock AI inference, EU — Frankfurt), Anthropic PBC (real-time AI API, USA — ZDR + SCC).',
    s6_title: '6. Your rights (Art. 15 to 22 GDPR)',
    s6_li: [
      'Right of access (Art. 15) — communication of processed data within 30 days.',
      'Right of rectification (Art. 16) — correction of inaccurate data.',
      'Right to erasure (Art. 17) — deletion of data (except legal obligation).',
      'Right to portability (Art. 20) — export of data in structured format (JSON/CSV).',
      'Right to object (Art. 21) — right to object to processing.',
      'Right to restriction (Art. 18) — restriction of processing.',
    ],
    s6_contact: 'To exercise your rights, contact us at info@aureussocial.be. We will respond within one month (Art. 12.3 GDPR).',
    s7_title: '7. Data breach',
    s7_p: 'In the event of a personal data breach, Aureus IA SRL undertakes to: notify the Data Protection Authority (DPA) within 72 hours in accordance with Article 33 GDPR; inform data subjects without delay if the breach is likely to result in a high risk to their rights and freedoms (Art. 34 GDPR); document the incident and corrective measures taken.',
    s8_title: '8. Cookies',
    s8_p: 'Aureus Social Pro exclusively uses strictly necessary cookies for the operation of the Service (authentication session, CSRF token, interface preferences). No tracking, analytics or advertising cookies are used. These functional cookies are exempt from consent in accordance with Article 5(3) of the ePrivacy Directive 2002/58/EC.',
    s9_title: '9. Supervisory authority',
    s9_apd: ['Data Protection Authority (DPA)', 'Rue de la Presse 35, 1000 Brussels', 'Tel: +32 2 274 48 00', 'Site: www.dataprotectionauthority.be', 'Email: contact@apd-gba.be'],
    s9_p: 'If you consider that the processing of your data constitutes a violation of GDPR, you have the right to lodge a complaint with the DPA.',
    s10_title: '10. Modifications',
    s10_p: 'This policy may be modified to reflect legal or technical evolutions. Any substantial modification will be notified by email to Clients at least 30 days before its entry into force. The current version is always available at www.aureussocial.be/legal/privacy.',
    footer: 'Document generated on 26 April 2026 — Version 2.0',
  },
  de: {
    title: 'Datenschutzerklärung',
    subtitle: 'Konform mit der Verordnung (EU) 2016/679 (DSGVO) und dem belgischen Gesetz vom 30. Juli 2018',
    updated: 'Letzte Aktualisierung: 26. April 2026',
    s1_title: '1. Verantwortlicher',
    s1_p1: 'Aureus IA SRL, ZUE BE 1028.230.781, Square Eugène Plasky 92-94 bte 11, Büro 10, 1030 Schaerbeek, Brüssel. E-Mail: info@aureussocial.be.',
    s1_p2: 'Aureus IA SRL handelt als Verantwortlicher für die Daten ihrer direkten Kunden (Nutzer des Dienstes) und als Auftragsverarbeiter im Sinne von Art. 28 DSGVO für die Verarbeitung der Mitarbeiterdaten ihrer Kunden.',
    s2_title: '2. Erhobene Daten',
    s2_th: ['Kategorie', 'Beispiele', 'Zweck'],
    s2_rows: [
      ['Identifikation', 'Name, RR-Nr, Geburtsdatum', 'Lohnberechnung, Sozialmeldungen'],
      ['Kontaktdaten', 'Adresse, E-Mail, Telefon', 'Kommunikation, Lohnabrechnungen'],
      ['Vertraglich', 'Vertragstyp, Lohn, Funktionen, PK', 'Lohnberechnung, Sozialrechtskonformität'],
      ['Bankdaten', 'IBAN (verschlüsselt AES-256-GCM)', 'Lohnüberweisungen (SEPA)'],
      ['Verbindung', 'Zugriffsprotokolle, IP, Browser', 'Sicherheit, Audit Trail'],
    ],
    s3_title: '3. Rechtsgrundlagen (Art. 6 DSGVO)',
    s3_li: [
      'Vertragserfüllung (Art. 6.1.b): Lohnverwaltung und Pflichtmeldungen.',
      'Rechtliche Verpflichtung (Art. 6.1.c): Dimona, DmfA, Belcotax, Aufbewahrung der Lohnabrechnungen (7 Jahre — Art. 315 EStGB 1992).',
      'Berechtigtes Interesse (Art. 6.1.f): Sicherheit, Betrugsprävention, Dienstverbesserung.',
      'Einwilligung (Art. 6.1.a): optionale Marketingkommunikation, nicht-strikt notwendige Cookies.',
    ],
    s4_title: '4. Hosting und technische Auftragsverarbeiter',
    s4_th: ['Dienst', 'Anbieter', 'Standort', 'Rolle'],
    s4_rows: [
      ['Datenbank', 'Supabase', 'Frankfurt, Deutschland (EU)', 'Speicherung und Authentifizierung'],
      ['Webanwendung', 'Vercel', 'Edge EU', 'Hosting der Anwendung'],
      ['Backups', 'Backblaze B2', 'EU Central', 'Tägliches verschlüsseltes Backup'],
      ['Transaktionale E-Mails', 'Resend', 'EU', 'Versand von Lohnabrechnungen'],
      ['Juristischer KI-Agent', 'AWS Bedrock (Claude) + Anthropic', 'EU — Frankfurt (primär) / USA — ZDR + SCC (Echtzeit-Streams)', 'KI-Antworten Sozialrecht (ohne Speicherung)'],
    ],
    s4_p: 'Die KI-Verarbeitung erfolgt innerhalb der Europäischen Union über AWS Bedrock (Region Frankfurt, eu-central-1), wenn das EU-Inferenz-Gateway aktiviert ist; es werden dann keine Daten außerhalb der EU übertragen. Wenn dieses Gateway nicht aktiv ist, laufen die Anfragen über die Anthropic-API (USA) unter dem Zero-Data-Retention-Regime und den Standardvertragsklauseln (SCC) der Europäischen Kommission. In allen Fällen werden direkte Identifikatoren (Nationalregisternummer/NISS, IBAN, E-Mail, Telefon) vor jeder Übermittlung automatisch pseudonymisiert (maskiert).',
    s5_title: '5. Auftragsverarbeiter',
    s5_p: 'Gemäß Artikel 28 DSGVO sind folgende Auftragsverarbeiter autorisiert. Eine Auftragsverarbeitungsvereinbarung (DPA) oder Standard Contractual Clauses (SCC) sind mit jedem von ihnen abgeschlossen: Supabase Inc. (Hosting, EU), Vercel Inc. (Deployment, EU), Resend Inc. (transaktionale E-Mails, EU), Backblaze Inc. (Backups, EU), Amazon Web Services EMEA SARL (Bedrock KI-Inferenz, EU — Frankfurt), Anthropic PBC (KI-API Echtzeit-Streams, USA — ZDR + SCC).',
    s6_title: '6. Ihre Rechte (Art. 15 bis 22 DSGVO)',
    s6_li: [
      'Auskunftsrecht (Art. 15) — Mitteilung der verarbeiteten Daten innerhalb von 30 Tagen.',
      'Recht auf Berichtigung (Art. 16) — Korrektur unrichtiger Daten.',
      'Recht auf Löschung (Art. 17) — Löschung der Daten (außer gesetzliche Verpflichtung).',
      'Recht auf Übertragbarkeit (Art. 20) — Export der Daten in strukturiertem Format (JSON/CSV).',
      'Widerspruchsrecht (Art. 21) — Recht auf Widerspruch gegen die Verarbeitung.',
      'Recht auf Einschränkung (Art. 18) — Einschränkung der Verarbeitung.',
    ],
    s6_contact: 'Um Ihre Rechte auszuüben, kontaktieren Sie uns unter info@aureussocial.be. Wir antworten innerhalb eines Monats (Art. 12.3 DSGVO).',
    s7_title: '7. Datenschutzverletzung',
    s7_p: 'Bei einer Verletzung personenbezogener Daten verpflichtet sich Aureus IA SRL: die Datenschutzbehörde (DSB) innerhalb von 72 Stunden gemäß Artikel 33 DSGVO zu benachrichtigen; die betroffenen Personen unverzüglich zu informieren, wenn die Verletzung voraussichtlich zu einem hohen Risiko für ihre Rechte und Freiheiten führt (Art. 34 DSGVO); den Vorfall und die getroffenen Korrekturmaßnahmen zu dokumentieren.',
    s8_title: '8. Cookies',
    s8_p: 'Aureus Social Pro verwendet ausschließlich streng notwendige Cookies für den Betrieb des Dienstes (Authentifizierungssitzung, CSRF-Token, Interface-Präferenzen). Es werden keine Tracking-, Analyse- oder Werbecookies verwendet. Diese funktionalen Cookies sind gemäß Artikel 5(3) der ePrivacy-Richtlinie 2002/58/EG von der Einwilligung befreit.',
    s9_title: '9. Aufsichtsbehörde',
    s9_apd: ['Datenschutzbehörde (DSB)', 'Rue de la Presse 35, 1000 Brüssel', 'Tel: +32 2 274 48 00', 'Site: www.datenschutzbehoerde.be', 'E-Mail: contact@apd-gba.be'],
    s9_p: 'Wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer Daten gegen die DSGVO verstößt, haben Sie das Recht, eine Beschwerde bei der DSB einzureichen.',
    s10_title: '10. Änderungen',
    s10_p: 'Diese Richtlinie kann geändert werden, um rechtlichen oder technischen Entwicklungen Rechnung zu tragen. Jede wesentliche Änderung wird den Kunden mindestens 30 Tage vor Inkrafttreten per E-Mail mitgeteilt. Die geltende Version ist immer unter www.aureussocial.be/legal/privacy verfügbar.',
    footer: 'Dokument erstellt am 26. April 2026 — Version 2.0',
  },
};

export default function PrivacyPage() {
  const [lang, setLang] = useLangueArrivee(Object.keys(CONTENT));

  const t = CONTENT[lang];

  const S = {
    h1: { fontSize: 26, fontWeight: 800, color: '#c6a34e', margin: '0 0 8px', letterSpacing: '-0.5px' },
    subtitle: { fontSize: 12, color: '#888', margin: '0 0 24px', lineHeight: 1.6 },
    section: { marginBottom: 28 },
    h2: { fontSize: 16, fontWeight: 700, color: '#e8e6e0', margin: '0 0 12px', paddingBottom: 8, borderBottom: '1px solid rgba(198,163,78,.12)' },
    p: { fontSize: 13, color: '#b0ada6', lineHeight: 1.8, margin: '0 0 10px' },
    updated: { fontSize: 10, color: '#666', marginBottom: 32, fontStyle: 'italic' },
    table: { width: '100%', borderCollapse: 'collapse', marginTop: 8 },
    th: { textAlign: 'left', padding: '8px 10px', borderBottom: '1px solid rgba(198,163,78,.2)', color: '#c6a34e', fontSize: 10, fontWeight: 600, textTransform: 'uppercase' },
    td: { padding: '8px 10px', borderBottom: '1px solid rgba(255,255,255,.04)', color: '#b0ada6', fontSize: 12 },
    li: { fontSize: 13, color: '#b0ada6', lineHeight: 1.8, marginLeft: 20 },
    box: { background: 'rgba(198,163,78,.05)', border: '1px solid rgba(198,163,78,.15)', borderRadius: 8, padding: 16, margin: '12px 0', fontSize: 12, color: '#e8e6e0' },
    langSelector: { display: 'flex', gap: 6, marginBottom: 20, flexWrap: 'wrap' },
    langBtn: (active) => ({
      padding: '6px 14px', borderRadius: 6, border: `1px solid ${active ? '#c6a34e' : 'rgba(198,163,78,.2)'}`,
      background: active ? 'rgba(198,163,78,.15)' : 'transparent', color: active ? '#c6a34e' : '#888',
      cursor: 'pointer', fontSize: 11, fontWeight: 600, fontFamily: 'inherit',
    }),
  };

  return (
    <div>
      <div style={S.langSelector}>
        {['fr', 'nl'].map(l => (
          <button key={l} onClick={() => setLang(l)} style={S.langBtn(lang === l)}>{l.toUpperCase()}</button>
        ))}
      </div>

      <h1 style={S.h1}>{t.title}</h1>
      <p style={S.subtitle}>{t.subtitle}</p>
      <p style={S.updated}>{t.updated}</p>

      <div style={S.section}>
        <h2 style={S.h2}>{t.s1_title}</h2>
        <p style={S.p}>{t.s1_p1}</p>
        <p style={S.p}>{t.s1_p2}</p>
      </div>

      <div style={S.section}>
        <h2 style={S.h2}>{t.s2_title}</h2>
        <table style={S.table}>
          <thead><tr>{t.s2_th.map((h, i) => <th key={i} style={S.th}>{h}</th>)}</tr></thead>
          <tbody>
            {t.s2_rows.map((r, i) => <tr key={i}>{r.map((c, j) => <td key={j} style={S.td}>{c}</td>)}</tr>)}
          </tbody>
        </table>
      </div>

      <div style={S.section}>
        <h2 style={S.h2}>{t.s3_title}</h2>
        <ul>{t.s3_li.map((l, i) => <li key={i} style={S.li}>{l}</li>)}</ul>
      </div>

      <div style={S.section}>
        <h2 style={S.h2}>{t.s4_title}</h2>
        <table style={S.table}>
          <thead><tr>{t.s4_th.map((h, i) => <th key={i} style={S.th}>{h}</th>)}</tr></thead>
          <tbody>
            {t.s4_rows.map((r, i) => <tr key={i}>{r.map((c, j) => <td key={j} style={S.td}>{c}</td>)}</tr>)}
          </tbody>
        </table>
        <p style={{ ...S.p, marginTop: 12 }}>{t.s4_p}</p>
      </div>

      <div style={S.section}>
        <h2 style={S.h2}>{t.s5_title}</h2>
        <p style={S.p}>{t.s5_p}</p>
      </div>

      <div style={S.section}>
        <h2 style={S.h2}>{t.s6_title}</h2>
        <ul>{t.s6_li.map((l, i) => <li key={i} style={S.li}>{l}</li>)}</ul>
        <p style={{ ...S.p, marginTop: 10 }}>{t.s6_contact}</p>
      </div>

      <div style={S.section}>
        <h2 style={S.h2}>{t.s7_title}</h2>
        <p style={S.p}>{t.s7_p}</p>
      </div>

      <div style={S.section}>
        <h2 style={S.h2}>{t.s8_title}</h2>
        <p style={S.p}>{t.s8_p}</p>
      </div>

      <div style={S.section}>
        <h2 style={S.h2}>{t.s9_title}</h2>
        <div style={S.box}>
          {t.s9_apd.map((line, i) => <div key={i} style={{ marginBottom: 4 }}>{i === 0 ? <strong>{line}</strong> : line}</div>)}
        </div>
        <p style={S.p}>{t.s9_p}</p>
      </div>

      <div style={S.section}>
        <h2 style={S.h2}>{t.s10_title}</h2>
        <p style={S.p}>{t.s10_p}</p>
      </div>

      <div style={{ marginTop: 40, padding: 20, border: '1px solid rgba(198,163,78,.2)', borderRadius: 8, textAlign: 'center', fontSize: 11, color: '#888' }}>
        Aureus IA SRL — BCE BE 1028.230.781 — info@aureussocial.be<br />
        <em>{t.footer}</em>
      </div>
    </div>
  );
}
